<div class="trial-insights-component relative">
  <!-- Header -->
  <aux-trial-insights-header [title]="title" [header]="total" [color]="color">
    <!-- Icon -->
    <ng-container icon>
      <aux-icon name="CalendarMinus" class="text-aux-green-dark" />
    </ng-container>
  </aux-trial-insights-header>

  <!-- Divider -->
  <div class="trial-insights-divider"></div>

  <!-- Chart Header -->
  <div class="trial-insights-chart-header">
    <!-- Warning icon and info for those trials whose
         currently enrolled has gone over expected enrolled -->
    @if (expectedEnrolledExceeded) {
      <div>
        <span class="icon" [auxTooltip]="exceedMessage">&#9888;</span>
      </div>
    }
  </div>

  <!-- Bar chart -->
  <div style="position: relative; height: 330px; width: 97%; margin: 10px 8px 4px 8px">
    <!-- Chart -->
    @if (!isLoading) {
      <canvas
        baseChart
        [type]="chartOptions.type"
        [data]="chartOptions.data"
        [options]="chartOptions.options"
      ></canvas>
    }
  </div>

  <!-- Legend -->
  <aux-trial-insights-legend [options]="legendOptions" />

  <!-- Divider -->
  <div class="trial-insights-divider full"></div>

  <!-- Table -->
  <aux-trial-insights-table
    [options]="tableOptions"
    [isLoadingRemaining]="isLoadingRemaining"
    [selectedKey]="selectedKey"
    [sortOrder]="sortOrder"
    [changeSelectedKey]="queryService.changeSelectedKey"
    [toggleSortOrder]="queryService.toggleSortOrder"
  />
</div>
